(function () {
  'use strict';
  var ROOT_SELECTOR = '#az_reviews,.areviews_main,[data-areviews-root]';
  var CARD_SELECTOR = '.AreviewsBody10-card,[class*="review-item"],[class*="review_item"],[class*="review-card"],[class*="review_card"],li';

  function reviewCards(root) {
    var candidates = [].slice.call(root.querySelectorAll(CARD_SELECTOR));
    return candidates.filter(function (el) {
      var text = (el.textContent || '').trim();
      if (text.length < 45) return false;
      return !candidates.some(function (other) {
        return other !== el && el.contains(other) && (other.textContent || '').trim().length > 45;
      });
    });
  }


  function lockCarouselLayout(track, cards) {
    var mobile = (window.innerWidth || document.documentElement.clientWidth || 9999) <= 749;
    track.style.setProperty('overflow-x', 'auto', 'important');
    track.style.setProperty('overflow-y', 'hidden', 'important');
    track.style.setProperty('width', '100%', 'important');
    track.style.setProperty('max-width', '100%', 'important');
    track.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
    track.style.setProperty('display', 'flex', 'important');
    track.style.setProperty('flex-wrap', 'nowrap', 'important');
    track.style.setProperty('align-items', 'stretch', 'important');
    track.style.setProperty('position', 'relative', 'important');
    track.style.setProperty('height', 'auto', 'important');
    if (mobile) {
      track.style.setProperty('gap', '12px', 'important');
      track.style.setProperty('padding', '14px 16px 18px', 'important');
    }
    cards.forEach(function (card) {
      var width = mobile ? 'calc(100vw - 56px)' : 'calc((100% - 36px) / 3)';
      card.style.setProperty('display', 'block', 'important');
      card.style.setProperty('float', 'none', 'important');
      card.style.setProperty('min-width', width, 'important');
      card.style.setProperty('width', width, 'important');
      card.style.setProperty('max-width', mobile ? '430px' : 'none', 'important');
      card.style.setProperty('flex', '0 0 ' + width, 'important');
      card.style.setProperty('position', 'relative', 'important');
      card.style.setProperty('inset', 'auto', 'important');
      card.style.setProperty('top', 'auto', 'important');
      card.style.setProperty('right', 'auto', 'important');
      card.style.setProperty('bottom', 'auto', 'important');
      card.style.setProperty('left', 'auto', 'important');
      card.style.setProperty('transform', 'none', 'important');
      card.style.setProperty('translate', 'none', 'important');
      card.style.setProperty('margin', '0', 'important');
      card.style.setProperty('z-index', 'auto', 'important');
      card.style.setProperty('scroll-snap-align', 'start', 'important');
    });
  }

  function move(track, direction) {
    var card = track.querySelector('.pmp-review-card');
    if (!card) return;
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap) || 18;
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }

  function addControls(root, track) {
    if (root.querySelector('.pmp-review-carousel-controls')) return;
    var controls = document.createElement('div');
    controls.className = 'pmp-review-carousel-controls';
    controls.setAttribute('aria-label', 'Review carousel controls');
    controls.innerHTML = '<button type="button" class="pmp-review-carousel-button pmp-review-carousel-prev" aria-label="Previous review">&#8592;</button><button type="button" class="pmp-review-carousel-button pmp-review-carousel-next" aria-label="Next review">&#8594;</button>';
    controls.querySelector('.pmp-review-carousel-prev').addEventListener('click', function () { move(track, -1); });
    controls.querySelector('.pmp-review-carousel-next').addEventListener('click', function () { move(track, 1); });
    track.insertAdjacentElement('afterend', controls);
  }

  function enhance() {
    [].slice.call(document.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
      var track = root.querySelector('.AreviewsBody10-grid.areviews_load_more_container,.AreviewsBody10-grid');
      var cards = track ? [].slice.call(track.querySelectorAll(':scope > .AreviewsBody10-card')) : reviewCards(root);
      if (cards.length < 2) return;
      track = track || cards[0].parentElement;
      if (!track || !cards.every(function (card) { return card.parentElement === track; })) return;
      track.classList.remove('pmp-review-masonry');
      track.classList.add('pmp-review-carousel');
      cards.forEach(function (card) { card.classList.add('pmp-review-card'); });
      lockCarouselLayout(track, cards);
      addControls(root, track);
      root.dataset.pmpReviewCarouselDone = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', enhance);
  window.addEventListener('resize', enhance, { passive: true });
  window.setTimeout(enhance, 500);
  window.setTimeout(enhance, 1500);
  window.setTimeout(enhance, 3500);
  new MutationObserver(enhance).observe(document.documentElement, { childList: true, subtree: true });
})();
